// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { CrisisCallCard } from '../../SagaSchema/CrisisCallCard';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class CrisisSimpleCallCard_abstract extends CrisisCallCard {
  static $t: string = 'SagaSchema.CrisisSimpleCallCard';
  $t: string = 'SagaSchema.CrisisSimpleCallCard';

  public static GetMembers(): string[] {
    return ['Reactivable'].concat(CrisisCallCard.GetMembers());
  }

  public GetMembers(): string[] {
    return CrisisSimpleCallCard_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  components(): string[] {
    return ['SagaSchema.CEvent', 'SagaSchema.CrisisCallCardProperties', 'SagaSchema.CLocation'];
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Reactivable: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
